<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <PageHeader :page-title="'Contractors Telegram Campaigns'">
            <template v-slot:buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
              <b-button
                variant="success"
                class="button"
                @click="() => showModal()"
                :disabled="isDataPageLoading"
              >
                Create
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="getTableFilters"
            :isLoading="isDataPageLoading"
            @submit="setFilters"
          />
          <TableForPage
            ref="table"
            :tableData="getTableData"
            :fields="getTableFields"
            :slots="getTableSlots"
            :perPage="getContractorTelegramCampaigns.per_page"
            :currentPage="getContractorTelegramCampaigns.current_page"
            :totalRows="getContractorTelegramCampaigns.total"
            :actions="getTableActions"
            isServerRender
            noLocalSorting
            @remove="remove"
            @edit="showModal"
            @start="start"
            @update="updateList"
          >
            <template v-slot:contractors="data">
              <span v-if="data.item.for_all">For All</span>
              <span v-else-if="data.item.contractors.length === 0">Selected telegram was removed</span>
              <div v-else v-for="telegram in data.item.contractors" v-bind:key="telegram.id">
                <span :key="telegram.id">{{ telegram.user.name }}</span>
              </div>
            </template>
          </TableForPage>
        </div>
      </div>
    </div>

    <ContractorTelegramCampaignModal
      v-model="modal.show"
      :form="modal.form"
      @save="save"
    />
  </div>
</template>

<script>
import PageHeader from '@components/PageHeader'
import Filters from '@components/Filter/Filter'
import TableForPage from '@tables/TableForPage'
import { mapGetters } from 'vuex'
import TelegramContractorsCampaignMixin from '@mixins/notifications/TelegramContractorsCampaignMixin'
import ContractorTelegramCampaignModal from '@components/modals/Telegram/ContractorTelegramCampaignModal'

export default {
  mixins: [TelegramContractorsCampaignMixin],
  components: {
    PageHeader,
    ContractorTelegramCampaignModal,
    Filters,
    TableForPage
  },
  data () {
    return { }
  },
  created () {
    this.fetchAllData()
  },
  computed: {
    ...mapGetters({
      getAvailableContractorTelegrams: 'telegram/getAvailableContractorTelegrams',
      getContractorTelegramCampaigns: 'telegram/getContractorTelegramCampaigns'
    }),
    getTableFilters () {
      return this.filters || {}
    },
    getTableFields () {
      return this.table.fields || []
    },
    getTableSlots () {
      return this.table.slots || []
    },
    getTableActions () {
      return this.table.actions || []
    },
    getTableData () {
      return this.getContractorTelegramCampaigns.data || []
    }
  },
  methods: {
    fetchAllData () {
      return Promise.all([
        this.fetchAvailableContractors(),
        this.fetchList()
      ]).then(() => {
        this.setAllOptions()
      })
    },
    setAllOptions () {
      this.modal.form.contractors.options = this.getAvailableContractorTelegrams
    },
    fetchAvailableContractors () {
      return this.$api.telegram.getAvailableContractorTelegrams()
    },
    fetchList () {
      let params = this.table.params.currentPage
      if (this.table.params.sorting) {
        params += this.table.params.sorting
      }
      if (this.table.params.filters) {
        params += this.table.params.filters
      }
      return this._toggleDataPageLoading(() => this.$api.telegram.getContractorTelegramCampaigns(params))
    },
    updateList (data) {
      if (!data) return this.fetchList()

      const { currentPage, sortDesc, sortBy } = data
      this.setParamsCurrentPage(currentPage)
      this.setParamsSort(sortDesc, sortBy)
      this.fetchList()
    },
    setFilters (data) {
      this.setParamsFilters(data)
      this.setParamsCurrentPage()
      this.fetchList()
    },
    save (data) {
      const campaign = this.prepareDataForRequest(data)
      const requestPromise = this.modal.campaignId
        ? this.$api.telegram.editContractorTelegramCampaign({ id: this.modal.campaignId, ...campaign })
        : this.$api.telegram.createContractorTelegramCampaign(campaign)
      requestPromise.then(() => {
        this.$snotify.success('Contractor telegram campaign successfully saved', 'Success', this.$store.state.snotify)
        this.hideModal()
        this.fetchList()
      }).catch(err => {
        const errors = Object.values(err.response.data.errors)
        for (let i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      })
    },
    async start (item) {
      const confirm = await this.$root.$confirm.open(
        'Start',
        'Are you sure you want to start the contractor telegram campaign?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(async () => {
        const startResponse = await this.$api.telegram.startContractorTelegramCampaign(item.id)
        this.$snotify.success(
          startResponse.data,
          'Success',
          this.$store.state.snotify
        )
      })
    },
    async remove (item) {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete the contractor telegram campaign?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(async () => {
        const deleteResponse = await this.$api.telegram.removeContractorTelegramCampaign(item.id)
        this.$snotify.success(
          deleteResponse.data,
          'Success',
          this.$store.state.snotify
        )
        this.updateList()
      })
    }
  }
}
</script>

<style>

</style>
